export default __webpack_public_path__ + "static/media/Knockout-HTF49-Liteweight.39c4a186.otf";